// SettingContext.js
import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { SettingsAPI } from "../api";

const SettingContext = createContext();

export const SettingContextProvider = ({ children }) => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await SettingsAPI.get({ skipAuth: true });
      setSettings(response.data?.data || []);
    } catch (error) {
      console.error("Failed to load settings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // 🔥 Helper function — getSetting("SOCIAL_MEDIA_FACEBOOK")
  const getSetting = useCallback(
    (name) => settings.find((s) => s.name === name)?.value || null,
    [settings],
  );

  return (
    <SettingContext.Provider value={{ settings, loading, getSetting }}>
      {children}
    </SettingContext.Provider>
  );
};

export const useSettingContext = () => {
  const context = useContext(SettingContext);
  if (!context) {
    throw new Error(
      "useSettingContext must be used within SettingContextProvider",
    );
  }
  return context;
};
